import React from "react"
import Grid from '@material-ui/core/Grid'

/* importing custom modules */
import Layout from '../components/layout'
import ContactForm from '../components/Custom Modules/ContactForm';
import SEO from "../components/seo"
import CustomImpact from "../components/Custom Modules/CustomImpact.js";

/* importing images */
import Logo from '../images/Impact/logo.png';

const Impact = () => (
  <Layout>
    <SEO 
      title="Impact" 
      description="Pratiiti - Impact of Pratiiti"
      canonical={"https://www.pratiiti.in/impact"}
    />
    <Grid xs={12} md={6} sm={3}>
      <div className="logo">
          <img src={Logo} alt="About US"/>
      </div>
    </Grid>
    <div>
        <CustomImpact/>
	  </div>
    <ContactForm/>
  </Layout>
)

export default Impact
